<template>
    <div class="container-bary">
        <v-chart :options="option"  autoresize/>
    </div>
</template>
<script>
import ECharts from 'vue-echarts'

import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/polar';
import 'echarts/lib/component/markPoint';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip'
import 'zrender/lib/svg/svg'



export default {
  name: 'barChartY',
  props: {  
   
  },
  data () {  
    return {     
       option:{}
    }
  },
  methods: {
 
  },
  mounted () {
    this.option = {  
        grid: {
            top:'10%',
            left: '8%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
             axisLabel: {             
                color:'#FFFFFF'
             },
            axisTick:{show:false},
            type: 'category',            
            data: ['会员一', '会员二', '会员三', '会员四', '会员五', '会员六', '会员七', '会员八']            
        },
        yAxis: {
              axisLabel: {     
                color:'#FFFFFF'   
              },
              type: 'value',
              splitLine:{ 
                 lineStyle:{
                     color: ['#292C38']
                 }
              }
        },       
        series: [
           {              
              type: 'bar',                     
              data: [21, 19, 10, 13, 8, 15, 18,22],
              itemStyle:{
                normal:{                   
             
                    color: function(params){
                        var c ='';                          
                        if(params.dataIndex==3){
                            c='#43D3C9'
                        }else{
                            c='#6648FF'
                        }
                        return c;
                    }
                  },                  
              },
              barWidth:22       
            }             
                
        ]
    };
  },
  components: {
      'v-chart': ECharts
  }  
}
</script>

<style lang="scss">

        .container-bary{
           height: 100%;
            width: 100%;
        .echarts{
            width: 100%;
            height: 100%;
        }
    }
</style>